import * as types from "./types";

// list
export const getDemoRequestsRequest = (payload) => ({
  type: types.GET_DEMO_REQUESTS_REQUEST,
  payload,
});

export const getDemoRequestsResponse = (payload) => ({
  type: types.GET_DEMO_REQUESTS_RESPONSE,
  payload,
});

export const updateDemoRequestRequest = (payload) => ({
  type: types.UPDATE_DEMO_REQUEST_REQUEST,
  payload,
});

export const deleteDemoRequestRequest = (payload) => ({
  type: types.DELETE_DEMO_REQUEST_REQUEST,
  payload,
});
